module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module chunks = 2